{
    "Rules_Validation_MustBeANumber": "Deve ser um número",
    "Rules_Validation_MustBeAnInteger": "Deve ser um número inteiro",
    "Rules_Validation_MustBeGreaterThanZero": "Deve ser maior que zero",
    "Rules_Validation_EmailMustBeValid": "O correio eletrónico deve ser válido",
    "Rules_Validation_MustBeLessThanMaxSafeInteger": "Maior que o valor máximo permitido",
    "Rules_Validation_MustBeLessThanLimit": "Deve ser inferior a {}",
    "Rules_Validation_MustMatch": "Deve corresponder",
    "Rules_Validation_MinLength": "Deve ter pelo menos {} caracteres",
    "Rules_Numbers_MaxSafeInteger": "o valor inteiro máximo",
    "NAME": "RulesLanguage",
    "Rules_Validation_ValidUrl": "Deve ser um URL válido",
    "Rules_Validate_Empty": "Este campo é obrigatório",
    "Rules_Validation_MaxLength": "Deve ter no máximo {} caracteres",
    "Rules_Validation_MaxWordLength": "Cada palavra deve ter no máximo {} caracteres",
    "Rules_Validation_IncorrectPattern": "O valor fornecido não é válido",
    "Rules_Validation_Unique": "O valor deve ser único",
    "Rules_Validation_ContentType": "O tipo de conteúdo deve ser um dos seguintes: {}",
    "Rules_Validation_MustBeUnderLimit": "Deve ser menor que {}"
}